import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

const router = new Router({
  mode: "history",
  linkExactActiveClass: 'selected',
  linkActiveClass: 'selected',
  base: process.env.BASE_URL,
  routes: [

    // Config Main Pags
    {
      path: "",
      component: () => import("./views/apps/Main.vue"),
      children: [
        {
          path: "/",
          redirect: "/apps/templates"
        },
        {
          path: "/apps/users",
          name: "Users",
          component: () => import("./views/apps/UserList.vue")
        },
        {
          path: "/apps/users/:id",
          name: "UserDetail",
          component: () => import("./views/apps/UserDetail.vue")
        },
        {
          path: "/apps/presentations",
          name: "Presentations",
          component: () => import("./views/apps/PresentationList.vue")
        },
        {
          path: "/apps/stickers",
          name: "Stickers",
          component: () => import("./views/apps/stickers/Stickers.vue")
        },
        {
          path: "/apps/stickers/:id",
          name: "StickerDetail",
          component: () => import("./views/apps/stickers/StickerDetail.vue")
        },
        {
          path: "/apps/survey-management",
          name: "SurveyManagement",
          component: () => import("./views/apps/survey-management/SurveyList.vue")
        },
        {
          path: "/apps/teams",
          name: "Teams",
          component: () => import("./views/apps/TeamList.vue")
        },
        {
          path: "/apps/teams/:id",
          name: "TeamDetail",
          component: () => import("./views/apps/TeamDetail.vue")
        },
        {
          path: "/apps/crawl",
          name: "CrawlData",
          component: () => import("./views/apps/CrawlData.vue")
        },
        {
          path: "/apps/templates",
          name: "Templates",
          component: () => import("./views/apps/templates/Templates.vue")
        },
        {
          path: "/apps/templates/:id",
          name: "TemplateDetail",
          component: () => import("./views/apps/templates/TemplateDetail.vue")
        },
        {
          path: "/apps/template-communities",
          name: "TemplateCommunities",
          component: () => import("./views/apps/template-communities/TemplateCommunities")
        },
        {
          path: "/apps/template-communities/:id",
          name: "TemplateCommunitiesDetail",
          component: () => import("./views/apps/template-communities/TemplateCommunitiesDetail")
        },
        {
          path: "/apps/templates-categories",
          name: "TemplateCategories",
          component: () => import("./views/apps/template-categories/TemplateCategories.vue")
        },
        {
          path: "/apps/templates-categories/:id",
          name: "TemplateCategoryDetail",
          component: () => import("./views/apps/template-categories/TemplateCategoryDetail")
        },
        {
          path: "/apps/templates-categories/create",
          name: "TemplateCategoryCreate",
          component: () => import("./views/apps/template-categories/TemplateCategoryCreate")
        },
        {
          path: "/apps/scim-api-keys",
          name: "ScimApiKey",
          component: () => import("./views/apps/scim-api-key/ScimApiKey.vue")
        },
        {
          path: "/apps/service-tokens",
          name: "ServiceTokens",
          component: () => import("./views/apps/service-tokens/ServiceTokens.vue")
        },
        {
          path: "/apps/request-removal",
          name: "RequestRemoval",
          component: () => import("./views/apps/request-removal/RequestRemoval.vue")
        },
        {
          path: "/apps/presentation-themes",
          name: "PresentationThemes",
          component: () => import("./views/apps/presentation-themes/PresentationThemes.vue")
        },
        {
          path: "/apps/notification",
          name: "NotificationPage",
          component: () => import("./views/apps/Notification.vue")
        },
        {
          path: "/apps/wordpress-cache",
          name: "WordpressCache",
          component: () => import("./views/apps/WordpressCache.vue")
        },
        {
          path: "/apps/links-generator",
          name: "WordpressLinksGenerator",
          component: () => import("./views/apps/LinksGenerator.vue")
        },
        {
          path: "/apps/webflow-sync",
          name: "WebflowSync",
          component: () => import("./views/apps/WebflowSync.vue")
        },
        {
          path: "/apps/stripe-price-sync",
          name: "StripePriceSync",
          component: () => import("./views/apps/StripePriceSync.vue")
        },
        {
          path: "/apps/global-configuration",
          name: "GlobalConfiguration",
          component: () => import("./views/apps/GlobalConfiguration.vue")
        },
        {
          path: "/apps/ads-campaign",
          name: "AdsCampaign",
          component: () => import("./views/apps/AdsCampaigns/AdsCampaign.vue")
        },
        {
          path: "/apps/template-collections",
          name: "TemplateCollectionList",
          component: () => import("./views/apps/template-collections/TemplateCollectionList.vue")
        },
        {
          path: "/apps/template-collections/:id",
          name: "TemplateCollectionDetails",
          component: () => import("./views/apps/template-collections/TemplateCollectionDetails.vue")
        },
        {
          path: "/apps/marketplace-licenses",
          name: "MarketplaceLicenseList",
          component: () => import("./views/apps/marketplace-license/MarketplaceLicenseList.vue")
        },
        {
          path: "/apps/account-manager",
          name: "AccountManagerList",
          component: () => import("./views/apps/account-manager/AccountManagerList.vue")
        },
        {
          path: "/apps/account-manager/:id",
          name: "AccountManagerDetails",
          component: () => import("./views/apps/account-manager/AccountManagerDetails.vue")
        },
        {
          path: "/apps/onboarding-journey",
          name: "OnboardingJourney",
          component: () => import("./views/apps/onboarding-journey/OnboardingJourney.vue")
        },
      ]
    },

    {
      path: '/auth',
      name: 'Auth',
      component: () => import('./views/apps/Auth.vue'),
    },

    // Config Full Pages
    {
      path: "/pages",
      redirect: "/pages/login",
    },
    {
      path: "/pages/login",
      name: "Login",
      component: () => import("./views/pages/Login.vue")
    },
  ]

})

router.beforeEach((to, from, next) => {
  const adminSession = Vue.cookie.get("ahaUserAdmin")
  const adminToken = Vue.cookie.get("ahaTokenAdmin")
  if (to.path === "/auth") {
    return next()
  } else if (adminSession || adminToken || to.path === "/pages/login") {
    // Any presenter login rewrites the shared ahaToken, including this app's own legacy token path,
    // which would leave the admin acting as the user they just opened.
    if (adminToken) {
      Vue.http.headers.common['Authorization'] = 'Bearer ' + adminToken
    }
    return next()
  } else {
    router.push("/pages/login")
  }
})

export default router
